// "unmask" is used to let FullStory capture the component

import type { RefObject } from 'react';

//   see: https://help.fullstory.com/hc/en-us/articles/360044349073-FullStory-Private-by-Default#01FHE22KSQ9J1N7DZ685G3M872
export type TextareaProps = {
    error?: boolean;
    unmask?: boolean;
    textareaRef?: RefObject<HTMLTextAreaElement>;
    height?: number | string;
    [key: string]: any;
};
export default function Textarea({
    error,
    unmask,
    textareaRef,
    height = 5,
    ...props
}: TextareaProps) {
    return (
        <textarea
            ref={textareaRef}
            style={{ height: typeof height === 'number' ? `${height}rem` : height }}
            className={`form-control ${error ? 'error' : ''} ${unmask ? 'fs-unmask' : ''}`}
            {...props}
            data-test-component='ui/forms/Textarea'
        />
    );
}
